import { participantIdTypeValues } from '../constants/types';
import suppressGlobalErrors from './suppressGlobalErrors';
import {
  postSurveyParticipants, verifyEmail, getStudents, getTeachers
} from '../api';

export const ADD_UNENROLLED_SURVEY_PARTICIPANTS = 'ADD_UNENROLLED_SURVEY_PARTICIPANTS';
export const ADD_UNENROLLED_SURVEY_PARTICIPANTS_FULFILLED = 'ADD_UNENROLLED_SURVEY_PARTICIPANTS_FULFILLED';
export const REMOVE_SURVEY_PARTICIPANT = 'REMOVE_SURVEY_PARTICIPANT';
export const SET_PARTICIPANT_EMAIL = 'SET_PARTICIPANT_EMAIL';
export const SELECT_PARTICIPANT_EMAIL = 'SELECT_PARTICIPANT_EMAIL';
export const SELECT_PARTICIPANT_EMAIL_FULFILLED = 'SELECT_PARTICIPANT_EMAIL_FULFILLED';
export const SET_SURVEY_PARTICIPANTS = 'SET_SURVEY_PARTICIPANTS';
export const SET_PARTICIPANT_EMAIL_FULFILLED = 'SET_PARTICIPANT_EMAIL_FULFILLED';
export const INIT_PARTICIPANTS = 'INIT_PARTICIPANTS';

export const addManualSurveyParticipantsAction = (ids) => suppressGlobalErrors({
  type: ADD_UNENROLLED_SURVEY_PARTICIPANTS,
  payload: getStudents(ids)
});

export const addParticipantsByEmailAction = (emails) => suppressGlobalErrors({
  type: ADD_UNENROLLED_SURVEY_PARTICIPANTS,
  payload: getTeachers(emails)
});

const { EXTERNAL_ID } = participantIdTypeValues;
export const removeSurveyParticipantAction = (id, idType = EXTERNAL_ID) => ({
  type: REMOVE_SURVEY_PARTICIPANT,
  payload: { id, idType }
});

export const selectParticipantEmailAction = (studentNumber, email) => ({
  type: SELECT_PARTICIPANT_EMAIL,
  payload: verifyEmail(studentNumber, email)
});

export const setParticipantEmailAction = (studentNumber, email) => ({
  type: SET_PARTICIPANT_EMAIL,
  payload: verifyEmail(studentNumber, email)
});

export const setSurveyParticipantsAction = (surveyId, participants) => ({
  type: SET_SURVEY_PARTICIPANTS,
  payload: postSurveyParticipants(surveyId, participants)
});

export const initSurveyParticipantsAction = (participants) => ({
  type: INIT_PARTICIPANTS,
  payload: participants
});
